<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 80 80"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M40 5C20.6719 5 5 20.6719 5 40C5 59.3281 20.6719 75 40 75C59.3281 75 75 59.3281 75 40C75 20.6719 59.3281 5 40 5ZM55.1172 28.5703L38.6641 51.3828C38.4341 51.7038 38.131 51.9653 37.7797 52.1457C37.4285 52.3261 37.0394 52.4203 36.6445 52.4203C36.2497 52.4203 35.8605 52.3261 35.5093 52.1457C35.1581 51.9653 34.855 51.7038 34.625 51.3828L24.8828 37.8828C24.5859 37.4688 24.8828 36.8906 25.3906 36.8906H29.0547C29.8516 36.8906 30.6094 37.2734 31.0781 37.9297L36.6406 45.6484L48.9219 28.6172C49.3906 27.9687 50.1406 27.5781 50.9453 27.5781H54.6094C55.1172 27.5781 55.4141 28.1562 55.1172 28.5703Z"
      fill="#13C27D"
    />
  </svg>
</template>

<script>
export default {
  props: {
    size: {
      default: 80,
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// CheckCircle.vue?5838bf1d